import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  Grid,
  CircularProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  SvgIcon,
} from '@mui/material';
import { styled } from '@mui/system';
import CloseIcon from '@mui/icons-material/Close';
import { DOMAIN } from '../../config';
import { ReactComponent as WechatIcon } from '../../icons/wechat.svg';
import { ReactComponent as TronIcon } from '../../icons/ton.svg'; // USDT-TRC20 图标
import {ReactComponent as AlipayIcon} from "../../icons/alipay.svg"

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StyledCard = styled(Card)(({ theme }) => ({
  textAlign: 'center',
  borderRadius: 16,
  transition: 'transform 0.3s',
  cursor: 'pointer',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: theme.shadows[6],
  },
  border: `2px solid transparent`,
  '&.selected': {
    borderColor: theme.palette.primary.main,
  },
}));

export default function MembershipPricing({ open, onClose }) {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [paymentDialogOpen, setPaymentDialogOpen] = useState(false);
  

  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await fetch(`${DOMAIN}pay/getGoods`, { credentials: 'include' });
        if (!response.ok) throw new Error('网络响应不是 OK');
        const result = await response.json();
        console.log(result)

        const planList = result?.map((item) => ({
          id: item.id,
          label: item.label,
          price: (item.price).toFixed(0),
          duration:
            item.label.includes('永久') ? '永久有效' :
            item.label.includes('1个月') ? '30天' :
            item.label.includes('3个月') ? '90天' :
            item.label.includes('半年') ? '180天' :
            item.label.includes('1年') ? '365天' :
            '自定义',
        })) || [];

        setPlans(planList);
      } catch (error) {
        console.error('出错:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchPlans();
  }, []);

  const handleClose = () => {
    setSelectedPlan(null);
    setPaymentDialogOpen(false);
    if (onClose) onClose();
  };

  const handlePaymentConfirm = () => {
    if (selectedPlan) {
      setPaymentDialogOpen(true);
    }
  };

  const handlePaymentMethod = (method) => {
    alert(`您选择了：${selectedPlan.label}，支付方式：${method}`);
    setPaymentDialogOpen(false);
    handleClose();
  };

  return (
    <>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar position="fixed" color="primary">
          <Toolbar>
            <Typography sx={{ flex: 1 }} variant="h6" component="div">
              选择会员套餐
            </Typography>
            <IconButton edge="end" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
          </Toolbar>
        </AppBar>

        <Box sx={{ pt: 8, pb: 10, px: 3, overflowY: 'auto', flex: 1 }}>
          {loading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={2}>
              {plans.map((plan) => (
                <Grid item xs={6} key={plan.label}>
                  <StyledCard
                    onClick={() => setSelectedPlan(plan)}
                    className={selectedPlan?.label === plan.label ? 'selected' : ''}
                  >
                    <CardContent>
                      <Typography variant="h6" gutterBottom>{plan.label}</Typography>
                      <Typography variant="h4" color="primary" gutterBottom sx={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'center' }}>
                        <Box component="span" sx={{ fontSize: '0.6em', verticalAlign: 'top', pr: 0.3 }}>¥</Box>
                        <Box component="span" sx={{ fontWeight: 700 }}>{plan.price}</Box>
                        <Box component="span" sx={{ fontSize: '0.6em', color: 'text.secondary', pl: 0.3 }}>元</Box>
                      </Typography>
                      <Typography variant="body2" color="text.secondary">有效期：{plan.duration}</Typography>
                    </CardContent>
                  </StyledCard>
                </Grid>
              ))}
            </Grid>
          )}
        </Box>

        {!loading && (
          <Box
            sx={{
              position: 'fixed',
              bottom: 0,
              left: 0,
              right: 0,
              p: 2,
              bgcolor: 'background.paper',
              borderTop: '1px solid #ddd',
            }}
          >
            <Button
              variant="contained"
              color="primary"
              fullWidth
              disabled={!selectedPlan}
              onClick={handlePaymentConfirm}
            >
              {selectedPlan ? `确认支付 ￥${selectedPlan.price}元` : '请选择一个套餐'}
            </Button>
          </Box>
        )}
      </Dialog>

      <PaymentMethodDialog
        open={paymentDialogOpen}
        onClose={() => setPaymentDialogOpen(false)}
        selectedPlan={selectedPlan}
        onConfirm={()=>{

        }}
      />
    </>
  );
}



function PaymentMethodDialog({ open, onClose, selectedPlan, onConfirm }) {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(false);
    const [qrInfo, setQrInfo] = useState(null); // 二维码信息
    const [qrLoading, setQrLoading] = useState(false);
    const [orderid,setOrderid] = useState()
    const [skuname,setSkuname] = useState()
    const [paymethod,setPaymethod] = useState()
    const [countdown, setCountdown] = useState(300); // 5分钟
    useEffect(() => {
    if (!qrInfo) return;
    const timer = setInterval(() => {
        setCountdown((prev) => {
        if (prev <= 1) {
            clearInterval(timer);
            return 0;
        }
        return prev - 1;
        });
    }, 1000);
    return () => clearInterval(timer);
    }, [qrInfo]);

    const formatCountdown = (sec) => {
    const m = String(Math.floor(sec / 60)).padStart(2, '0');
    const s = String(sec % 60).padStart(2, '0');
    return `${m}:${s}`;
    };

  
    const handleSelect = async (orderid,name,method) => {
      console.log(method)
      const methodlist = {
        "wxpay":"微信",
        "alipay":"支付宝",
        "crypto":"USDT"
      }
      setPaymethod(methodlist[method])
      try {
        setQrLoading(true);
        const response = await fetch(`${DOMAIN}pay/payOrder?skuname=${skuname}&orderid=${orderid}&method=${method}`, {
          credentials: 'include',
        });
        const result = await response.json()
        if (result?.qrcode && result?.payUrl) {
          setQrInfo({
            qrcode: result.qrcode,
            payUrl: result.payUrl,
          });
        } else {
          alert("未获取到二维码支付信息");
        }
      } catch (err) {
        console.error('获取二维码失败:', err);
        alert("获取二维码失败");
      } finally {
        setQrLoading(false);
      }
    };
  
    useEffect(() => {
      const fetchPayMethod = async () => {
        if (!selectedPlan?.id) return;
        setLoading(true);
        try {
          const response = await fetch(`${DOMAIN}pay/createOrder?skuid=${selectedPlan.id}`, {
            credentials: 'include',
          });
          const result = await response.json();
          setOrderid(result.id)
          setPayments(result.payments || []);
          setSkuname(result.skuName)
        } catch (error) {
          console.error('创建订单失败:', error);
        } finally {
          setLoading(false);
        }
      };
  
      if (open) {
        fetchPayMethod();
        setQrInfo(null); // 每次打开重置二维码信息
      }
    }, [selectedPlan, open]);

    const getPaymentIcon = (method) => {
        switch (method?.toLowerCase()) {
          case '支付宝':
          case 'alipay':
            return <SvgIcon component={AlipayIcon} inheritViewBox sx={{ mr: 1 }} />;
          case '微信':
          case 'wechat':
            return <SvgIcon component={WechatIcon} inheritViewBox sx={{ mr: 1 }} />;
          case 'crypto':
          case 'usdt':
            return <SvgIcon component={TronIcon} inheritViewBox sx={{ mr: 1 }} />;
          default:
            return null;
        }
    };
  
    const enabledPayments = payments.filter(p => p.enabled);
  
    return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>选择支付方式</DialogTitle>
        <DialogContent>
          {qrInfo ? (
            <Box sx={{ textAlign: 'center', mt: 2 }}>
              {qrLoading ? (
                <CircularProgress />
              ) : (
                <>
                    <img
                        src={qrInfo.qrcode}
                        alt="支付二维码"
                        style={{ width: '200px', height: '200px', marginBottom: 12 }}
                    />

                    {/* ✨ 订单详情卡片区域 */}
                    <Box
                        sx={{
                        bgcolor: '#f5f7fa',
                        borderRadius: 2,
                        border: '1px solid #e0e0e0',
                        padding: 2,
                        mb: 2,
                        width: '90%',
                        maxWidth: 280,
                        mx: 'auto',
                        boxShadow: 1,
                        }}
                    >
                        <Typography variant="subtitle1" gutterBottom fontWeight="bold" color="primary">
                        订单详情
                        </Typography>

                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                        <strong>订单编号：</strong> {orderid || '加载中'}
                        </Typography>

                        <Typography variant="body2" sx={{ mb: 0.5 }}>
                        <strong>商品名称：</strong> {skuname || selectedPlan?.label || '加载中'}
                        </Typography>

                        <Typography
                            variant="body2"
                            sx={{
                                color: countdown === 0
                                ? 'error.main'
                                : countdown <= 120
                                ? 'error.main'
                                : 'text.secondary',
                                fontWeight: countdown <= 120 ? 'bold' : 'normal',
                            }}
                            >
                            <strong>有效期：</strong>{' '}
                            {countdown === 0
                                ? '此订单已失效'
                                : `${formatCountdown?.(countdown) || '05:00'} 内完成支付`}
                        </Typography>
                    </Box>

                    <Typography variant="body1" gutterBottom>
                    您可以点击下方的跳转支付按钮进行支付，也可以截屏保存二维码到相册后使用微信或支付宝扫码支付。请用手机自带浏览器打开支付链接, 如果无法打开支付页面, 请关闭VPN或切换网络
                    </Typography>

                    <Button
                        variant="outlined"
                        href={qrInfo.payUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        startIcon={getPaymentIcon(paymethod)}
                        >
                        打开{getPaymentLabel(paymethod)}支付
                    </Button>
                </>
              )}
            </Box>
          ) : (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
              {loading ? (
                <Typography color="text.secondary">正在加载支付方式...</Typography>
              ) : enabledPayments.length > 0 ? (
                enabledPayments.map((p) => (
                  <Button
                    key={p.method}
                    variant="contained"
                    onClick={() => handleSelect(orderid,p.name,p.method)}
                  >
                    使用 {getPaymentLabel(p.name)}
                  </Button>
                ))
              ) : (
                <Typography color="text.secondary">暂无可用支付方式</Typography>
              )}
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>取消</Button>
          {qrInfo && (
            <Button onClick={() => setQrInfo(null)} color="secondary">
              返回支付方式
            </Button>
          )}
        </DialogActions>
      </Dialog>
    );
  }
  
  // 支付方式映射
  function getPaymentLabel(name) {
    const map = {
      apple: 'Apple Pay',
      google: 'Google Pay',
      crypto: 'USDT',
      alipay: '支付宝',
      wxpay: '微信支付',
      paypal: 'PayPal',
    };
    return map[name?.toLowerCase()] || name;
  }
  

